const weights = [3, 2, 7, 6, 5, 4, 3, 2];
const regex = /^\d{10}$/;

export function isKennitala(kennitala?: string): boolean {
	if (!kennitala || !regex.test(kennitala)) return false;

	if (kennitala.startsWith('8')) return true;

	const digits = kennitala.split('').map(Number);
	const rawDay = Number(kennitala.slice(0, 2));
	const month = Number(kennitala.slice(2, 4));
	const year = Number(kennitala.slice(4, 6));
	const centuryIndicator = digits[9];
	const day = rawDay >= 41 && rawDay <= 71 ? rawDay - 40 : rawDay;

	let fullYear: number;

	switch (centuryIndicator) {
		case 9:
			fullYear = 1900 + year;
			break;
		case 0:
			fullYear = 2000 + year;
			break;
		default:
			return false;
	}

	const date = new Date(fullYear, month - 1, day);

	if (date.getFullYear() !== fullYear || date.getMonth() !== month - 1 || date.getDate() !== day) {
		return false;
	}

	return hasValidChecksum(digits);
}

export function isCompany(kennitala: string) {
	const x = Number(kennitala.slice(0, 2));
	return isKennitala(kennitala) && Number.isSafeInteger(x) && x >= 41 && x <= 71;
}

export function isAtLeast18(kennitala: string): boolean {
	if (!isKennitala(kennitala)) return false;
	if (kennitala.startsWith('8')) return false;

	const rawDay = Number(kennitala.slice(0, 2));
	const dd = String(rawDay >= 41 && rawDay <= 71 ? rawDay - 40 : rawDay).padStart(2, '0');
	const mm = kennitala.slice(2, 4);
	const yy = kennitala.slice(4, 6);

	const century = kennitala[9] === '0' ? 2000 : 1900;
	const year = century + Number(yy);
	const birthDate = new Date(`${year}-${mm}-${dd}`);

	const today = new Date();
	const cutoff = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate());

	return birthDate <= cutoff;
}

function hasValidChecksum(digits: number[]): boolean {
	const sum = weights.reduce((acc, weight, index) => acc + digits[index] * weight, 0);
	const remainder = sum % 11;
	const expected = remainder === 0 ? 0 : 11 - remainder;
	return expected !== 10 && digits[8] === expected;
}
